import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import CircularNicknameSvg from '../components/CircularNicknameSvg';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage, auth } from '../config/firebasedeconfig';
import {
    getFirestore,
    collection,
    doc,
    getDoc,
    getDocs,
    getCountFromServer,
    limit as firestoreLimit,
    orderBy,
    query,
    serverTimestamp,
    startAfter,
    updateDoc,
} from "firebase/firestore";
import { UserContext } from '../UserContext';
import { defaultBannerUrl, defaultAvatarUrl } from '../constants';
import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import SearchMovieForEdit from "../components/SearchMovieForEdit";
import styles from '../styles/components/EditProfil.scss';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // import styles
// import 'quill/dist/quill.snow.css';
import he from 'he';
// import { countries as countryData } from 'countries-list';
import { Country, State, City } from 'country-state-city';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import PreviewMyFavoritesMovies from '../components/PreviewMyFavoritesMovies';
import MyFavoritesActors from '../components/MyFavoritesActors';
import My3FavoriteCategories from '../components/My3FavoriteCategories';
import PreviewMovie from '../components/PreviewMovie';
import { RefreshContext } from '../components/RefreshContext';
import Movie from '../components/Movie';
import { Helmet } from "react-helmet-async"; // Ajout de Helmet pour le SEO
import { useLanguage } from '../contexts/LanguageContext';
import { XP_WEIGHTS } from "../components/levelUtils";
import { ConfirmFavoriteDialog } from "../components/ConfirmFavoriteDialog";

const PROFILE_ACTIVITY_GAINS_STORAGE_KEY = "movieFrenzy.profileActivityGains";

const formatActivityGainPoints = (value) => {
    const number = Number(value) || 0;

    return `+${Number.isInteger(number)
        ? number
        : number.toFixed(2).replace(/\.?0+$/, "")
        }`;
};

const normalizeXpSource = (value) => {
    const number = Number(value);

    if (!Number.isFinite(number)) {
        return 0;
    }

    return Math.max(0, number);
};

const EditProfil = () => {
    const { t } = useLanguage();
    const { refreshNeeded, setRefreshNeeded } = useContext(RefreshContext);
    const [biography, setBiography] = useState("");
    const [quote, setQuote] = useState("");
    const [favoriteCategories, setFavoriteCategories] = useState([]);
    const [favoriteMovies, setFavoriteMovies] = useState([]);
    const [favoriteActors, setFavoriteActors] = useState([]);
    const [favoritePreviews, setFavoritePreviews] = useState([]);
    const [movieReviews, setMovieReviews] = useState([]);
    const [movieReviewsLoading, setMovieReviewsLoading] = useState(true);
    const [movieReviewsError, setMovieReviewsError] = useState(false);
    const [updatingMovieReviewId, setUpdatingMovieReviewId] = useState(null);

    const [movieReviewPages, setMovieReviewPages] = useState([]);
    const [movieReviewPageIndex, setMovieReviewPageIndex] = useState(0);
    const [movieReviewsTotal, setMovieReviewsTotal] = useState(0);
    const [movieReviewsPageLoading, setMovieReviewsPageLoading] = useState(false);

    const isMovieReviewsMobile = useMediaQuery({
        maxWidth: 768,
    });

    const isMovieReviewsTablet = useMediaQuery({
        minWidth: 769,
        maxWidth: 1200,
    });

    const movieReviewsPageSize = isMovieReviewsMobile
        ? 4
        : isMovieReviewsTablet
            ? 6
            : 8;


    const [country, setCountry] = useState('');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [gender, setGender] = useState("");
    const [age, setAge] = useState("");
    const [zodiacSign, setZodiacSign] = useState("");
    const [occupation, setOccupation] = useState("");


    const countries = Country.getAllCountries();
    // const states = country ? State.getStatesOfCountry(country.isoCode) : [];
    const states = country ? State.getStatesOfCountry(country) : [];
    console.log("Available states for the selected country:", states);
    const cities = state ? City.getCitiesOfState(country, state) : [];
    console.log("Available cities for the selected state:", cities);

    const [isHovered, setIsHovered] = useState(false);
    const [isHoveredId, setIsHoveredId] = useState(null);
    const [isSaveClicked, setIsSaveClicked] = useState(false);
    const [deletingFavoriteKey, setDeletingFavoriteKey] = useState(null);

    const TTL = 24 * 60 * 60 * 1000;

    const history = useNavigate();

    // Récupérez l'ID de l'utilisateur depuis l'authentification Firebase
    const { userId } = useParams();

    const db = getFirestore();
    const userRef = doc(db, "users", userId);

    const movieReviewsTotalPages = Math.max(
        1,
        Math.ceil(
            movieReviewsTotal / movieReviewsPageSize
        )
    );

    const canGoToPreviousMovieReviewsPage =
        movieReviewPageIndex > 0;

    const canGoToNextMovieReviewsPage =
        movieReviewPageIndex + 1 <
        movieReviewsTotalPages;

    const stripHtml = (value = "") => {
        return he
            .decode(String(value || ""))
            .replace(/<[^>]*>/g, " ")
            .replace(/&nbsp;/g, " ")
            .replace(/\s+/g, " ")
            .trim();
    };

    const clampFavoriteCount = (items = []) => {
        if (!Array.isArray(items)) {
            return 0;
        }

        return Math.min(items.length, 3);
    };

    const hasValidPreviewMovie = (movie) => {
        return Boolean(movie && (movie.id || movie.title || movie.name));
    };

    const handleSave = async () => {
        setIsSaveClicked(true);

        if (!auth.currentUser) {
            console.error("Aucun utilisateur n'est connecté.");
            history('/connexion');
            return;
        }

        try {
            const userSnap = await getDoc(userRef);
            const previousXpSources = userSnap.exists()
                ? userSnap.data()?.xp?.sources || {}
                : {};

            const cleanedBiography = he.decode(biography);

            const biographyText = stripHtml(cleanedBiography);
            const quoteText = stripHtml(quote);

            const nextProfileCompleted =
                biographyText.length >= 30 && quoteText.length >= 5 ? 1 : 0;

            const nextProfilePreview = hasValidPreviewMovie(selectedMovie) ? 1 : 0;

            const nextFavoriteMoviesCount = clampFavoriteCount(favoritePreviews);
            const nextFavoriteActorsCount = clampFavoriteCount(favoriteActors);
            const nextFavoriteGenresCount = clampFavoriteCount(favoriteCategories);

            const nextZodiacProfile =
                typeof zodiacSign === "string" && zodiacSign.trim() !== "" ? 1 : 0;

            const now = Date.now();

            const profileActivityGains = [];

            if (
                normalizeXpSource(previousXpSources.profileCompleted) <= 0 &&
                nextProfileCompleted === 1
            ) {
                profileActivityGains.push({
                    id: `profile-completed-${now}`,
                    points: formatActivityGainPoints(XP_WEIGHTS.profileCompleted),
                    labelKey: "activityToast.profileCompleted",
                    variant: "profile",
                });
            }

            if (
                normalizeXpSource(previousXpSources.profilePreview) <= 0 &&
                nextProfilePreview === 1
            ) {
                profileActivityGains.push({
                    id: `profile-preview-${now}`,
                    points: formatActivityGainPoints(XP_WEIGHTS.profilePreview),
                    labelKey: "activityToast.profilePreview",
                    variant: "preview",
                });
            }

            if (
                normalizeXpSource(previousXpSources.zodiacProfile) <= 0 &&
                nextZodiacProfile === 1
            ) {
                profileActivityGains.push({
                    id: `zodiac-profile-${now}`,
                    points: formatActivityGainPoints(XP_WEIGHTS.zodiacProfile),
                    labelKey: "activityToast.zodiacProfile",
                    variant: "zodiac",
                });
            }

            await updateDoc(userRef, {
                biography: cleanedBiography,
                quote: quote,
                favoriteCategories: favoriteCategories,
                favoriteMovies: favoriteMovies,
                favoriteActors: favoriteActors,
                gender: gender,
                age: age,
                zodiacSign: zodiacSign,
                occupation: occupation,
                country: country,
                state: state,
                city: city,
                favoriteMovie: selectedMovie,
                favoritePreviews: favoritePreviews,
                PreviewMovie: selectedMovie,

                "xp.sources.profileCompleted": nextProfileCompleted,
                "xp.sources.profilePreview": nextProfilePreview,
                "xp.sources.favoriteMovies": nextFavoriteMoviesCount,
                "xp.sources.favoriteActors": nextFavoriteActorsCount,
                "xp.sources.favoriteGenres": nextFavoriteGenresCount,
                "xp.sources.zodiacProfile": nextZodiacProfile,
                "xp.updatedAt": serverTimestamp(),
            });

            try {
                if (profileActivityGains.length > 0) {
                    window.sessionStorage.setItem(
                        PROFILE_ACTIVITY_GAINS_STORAGE_KEY,
                        JSON.stringify(profileActivityGains)
                    );
                } else {
                    window.sessionStorage.removeItem(PROFILE_ACTIVITY_GAINS_STORAGE_KEY);
                }
            } catch (storageError) {
                console.warn(
                    "[MovieFrenzy] Impossible de stocker les gains d'activité du profil :",
                    storageError
                );
            }

            history(`/profilMemberPage/${userId}?showAnimation=true`);
        } catch (error) {
            console.error("Erreur lors de la mise à jour du profil:", error);
        }
    };

    const [selectedMovie, setSelectedMovie] = useState(null);

    const handleMovieSelected = (movie) => {
        setSelectedMovie(movie);
        // Ici, vous pouvez également stocker l'URL du preview YouTube ou d'autres informations pertinentes.
    };

    function getWithExpiry(key) {
        const itemStr = localStorage.getItem(key);
        // Si l'item n'existe pas, retourner null
        if (!itemStr) {
            return null;
        }
        const item = JSON.parse(itemStr);
        const now = new Date();
        // Comparer la date d'expiration avec la date actuelle
        if (now.getTime() > item.expiry) {
            // Si l'item est expiré, le supprimer du stockage et retourner null
            localStorage.removeItem(key);
            return null;
        }
        return item.value;
    }


    function setWithExpiry(key, value, ttl) {
        const now = new Date();
        const item = {
            value: value,
            expiry: now.getTime() + ttl,
        };
        localStorage.setItem(key, JSON.stringify(item));
    }


    // Appelé lorsqu'un pays est sélectionné
    const handleCountryChange = (selectedCountryCode) => {
        setCountry(selectedCountryCode);
        setState(''); // Réinitialiser l'état
        setCity('');  // Réinitialiser la ville

        // Charger les états pour le nouveau pays sélectionné
        const cacheKey = `states_${selectedCountryCode}`;
        const cachedStates = getWithExpiry(cacheKey);
        console.log("Récupération du stockage local : " + cachedStates);
        if (!cachedStates) {
            const loadedStates = State.getStatesOfCountry(selectedCountryCode);
            setWithExpiry(cacheKey, loadedStates, TTL);
            setState(loadedStates);
        } else {
            setState(cachedStates);
        }
    };

    // Appelé lorsqu'un état est sélectionné
    const handleStateChange = (selectedStateCode) => {
        setState(selectedStateCode);
        setCity(''); // Réinitialiser la ville

        // Charger les villes pour le nouvel état sélectionné
        const cacheKey = `cities_${country}_${selectedStateCode}`;
        const cachedCities = getWithExpiry(cacheKey);
        if (!cachedCities) {
            const loadedCities = City.getCitiesOfState(country, selectedStateCode);
            setWithExpiry(cacheKey, loadedCities, TTL);
            setCity(loadedCities);
        } else {
            setCity(cachedCities);
        }
    };



    useEffect(() => {
        console.log("Country has changed:", country);
        console.log("States:", states);
    }, [country]);

    useEffect(() => {
        console.log("State has changed:", state);
        console.log("Cities:", cities);
    }, [state]);

    useEffect(() => {
        console.log("City has changed:", city);
    }, [city]);

    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                const userSnap = await getDoc(userRef);
                const userData = userSnap.data();
                console.log("UserData from Firestore:", userData);

                if (!userSnap.exists()) {
                    // Initialisation aux premières valeurs par défaut en cas d'absence de données
                    const defaultData = {
                        biography: "",
                        quote: "",
                        favoriteCategories: [],
                        favoriteMovies: [],
                        favoriteActors: [],
                        favoritePreviews: [],
                        selectedMovie: null,
                        gender: "other",
                        age: "",
                        occupation: "other",
                        zodiacSign: "",
                        country: 'Choix du pays',
                        state: 'Choix de l\'état ou de la province',
                        city: 'Choix de la ville',
                        favoriteMovie: null,
                        subscription: {
                            planId: "free",
                            billingPeriod: "monthly",
                            paypalSubscriptionId: null,
                            status: "none",
                            currentPeriodEnd: null
                        }
                    };

                    setBiography(defaultData.biography);
                    setQuote(defaultData.quote);
                    setFavoriteCategories(defaultData.favoriteCategories);
                    setFavoriteMovies(defaultData.favoriteMovies);
                    setFavoriteActors(defaultData.favoriteActors);
                    setGender(defaultData.gender);
                    setAge(defaultData.age);
                    setOccupation(defaultData.occupation);
                    setZodiacSign(defaultData.zodiacSign);
                    setCountry(defaultData.country);
                    setState(defaultData.state);
                    setCity(defaultData.city);
                    setSelectedMovie(defaultData.favoriteMovie);
                    setFavoritePreviews(defaultData.favoritePreviews);
                    // Mise à jour Firestore avec les données par défaut
                    await updateDoc(userRef, defaultData);
                    return;
                }

                // Utiliser les données récupérées de Firestore
                // Si la donnée est undefined, utilisez une valeur par défaut
                setBiography(userData.biography || "");
                setQuote(userData.quote || "");
                setFavoriteCategories(userData.favoriteCategories || []);
                setFavoriteMovies(userData.favoriteMovies || []);
                setFavoriteActors(userData.favoriteActors || []);
                setFavoritePreviews(userData.favoritePreviews || []);
                setGender(userData.gender || "other");
                setAge(userData.age || "");
                setOccupation(userData.occupation || "other");
                setZodiacSign(userData.zodiacSign || "");
                setCountry(userData?.country ?? 'Choix du pays');
                setState(userData?.state ?? 'Choix de l\'état ou de la province');
                setCity(userData?.city ?? 'Choix de la ville');
                setSelectedMovie(userData.favoriteMovie || null);

            } catch (error) {
                console.error("Erreur lors de la récupération des détails de l'utilisateur:", error);
            }
        };

        fetchUserDetails();
    }, []);

    // CHARGEMENT PAGINÉ DES AVIS MOVIEFRENZY
    useEffect(() => {
        if (!userId) {
            setMovieReviews([]);
            setMovieReviewPages([]);
            setMovieReviewsTotal(0);
            setMovieReviewPageIndex(0);
            setMovieReviewsLoading(false);
            return;
        }

        let isMounted = true;

        const fetchFirstMovieReviewsPage = async () => {
            setMovieReviewsLoading(true);
            setMovieReviewsError(false);

            try {
                const reviewsCollectionRef = collection(
                    db,
                    "users",
                    userId,
                    "movieReviews"
                );

                const firstPageQuery = query(
                    reviewsCollectionRef,
                    orderBy("updatedAt", "desc"),
                    firestoreLimit(movieReviewsPageSize)
                );

                const [countSnapshot, firstPageSnapshot] =
                    await Promise.all([
                        getCountFromServer(
                            reviewsCollectionRef
                        ),
                        getDocs(firstPageQuery),
                    ]);

                if (!isMounted) return;

                const loadedReviews =
                    firstPageSnapshot.docs.map(
                        (reviewDoc) => ({
                            id: reviewDoc.id,
                            ...reviewDoc.data(),
                        })
                    );

                const lastDoc =
                    firstPageSnapshot.docs[
                    firstPageSnapshot.docs.length - 1
                    ] || null;

                setMovieReviewsTotal(
                    countSnapshot.data().count
                );

                setMovieReviewPages([
                    {
                        reviews: loadedReviews,
                        lastDoc,
                    },
                ]);

                setMovieReviewPageIndex(0);
                setMovieReviews(loadedReviews);
            } catch (error) {
                console.error(
                    "[MovieFrenzy] Erreur lors du chargement paginé des avis :",
                    error
                );

                if (isMounted) {
                    setMovieReviews([]);
                    setMovieReviewPages([]);
                    setMovieReviewsTotal(0);
                    setMovieReviewsError(true);
                }
            } finally {
                if (isMounted) {
                    setMovieReviewsLoading(false);
                }
            }
        };

        fetchFirstMovieReviewsPage();

        return () => {
            isMounted = false;
        };
    }, [
        db,
        userId,
        movieReviewsPageSize,
    ]);

    const [allCountries, setAllCountries] = useState([]);

    useEffect(() => {
        setAllCountries(Country.getAllCountries());
    }, []);



    useEffect(() => {
        console.log("Initialized Country:", country);
    }, [country]);

    useEffect(() => {
        console.log("Initialized State:", state);
    }, [state]);

    useEffect(() => {
        console.log("Initialized City:", city);
    }, [city]);


    useEffect(() => {
        console.log('Biography a changé:', biography);
    }, [biography]);

    const handleDeleteAccount = async () => {
        if (window.confirm('Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.')) {
            try {
                // Supprimer le document Firestore associé à l'utilisateur
                await updateDoc(userRef, { /* mettre ici les champs à supprimer ou à mettre à jour */ });

                // Supprimer le compte utilisateur de Firebase Auth
                const users = auth.currentUser;
                await users.delete();

                // Rediriger vers la page d'accueil ou de connexion
                history('/');
            } catch (error) {
                console.error("Erreur lors de la suppression du compte:", error);
            }
        }
    };

    const handleDeleteFavorite = async (type, id) => {
        if (deletingFavoriteKey) {
            return;
        }

        let currentFavorites = [];
        let setFavorites = null;
        let firestoreField = "";
        let xpSourceField = "";
        let dialogTitle = "";

        switch (type) {
            case "movie":
                currentFavorites = favoritePreviews;
                setFavorites = setFavoritePreviews;
                firestoreField = "favoritePreviews";
                xpSourceField = "xp.sources.favoriteMovies";
                dialogTitle = t(
                    "confirmFavoriteDialog.movieTitle"
                );
                break;

            case "actor":
                currentFavorites = favoriteActors;
                setFavorites = setFavoriteActors;
                firestoreField = "favoriteActors";
                xpSourceField = "xp.sources.favoriteActors";
                dialogTitle = t(
                    "confirmFavoriteDialog.actorTitle"
                );
                break;

            case "category":
                currentFavorites = favoriteCategories;
                setFavorites = setFavoriteCategories;
                firestoreField = "favoriteCategories";
                xpSourceField = "xp.sources.favoriteGenres";
                dialogTitle = t(
                    "confirmFavoriteDialog.categoryTitle"
                );
                break;

            default:
                console.error("Type de favori inconnu :", type);
                return;
        }

        const favoriteToDelete = currentFavorites.find(
            (favorite) => String(favorite.id) === String(id)
        );

        if (!favoriteToDelete) {
            console.error(
                `Favori introuvable pour le type ${type} et l'id ${id}`
            );
            return;
        }

        const favoriteName =
            favoriteToDelete.title ||
            favoriteToDelete.name ||
            favoriteToDelete.original_name ||
            "Ce favori";

        const confirmed = await ConfirmFavoriteDialog.call({
            title: dialogTitle,
            itemName: favoriteName,
        });

        if (!confirmed) {
            return;
        }

        const favoriteKey = `${type}-${id}`;

        const updatedFavorites = currentFavorites.filter(
            (favorite) => String(favorite.id) !== String(id)
        );

        try {
            setDeletingFavoriteKey(favoriteKey);

            // Firestore est mis à jour avant de retirer visuellement la carte.
            await updateDoc(userRef, {
                [firestoreField]: updatedFavorites,
                [xpSourceField]: clampFavoriteCount(updatedFavorites),
                "xp.updatedAt": serverTimestamp(),
            });

            setFavorites(updatedFavorites);
            setRefreshNeeded(true);
        } catch (error) {
            console.error(
                `Erreur lors de la suppression du favori de type ${type} avec l'id ${id} :`,
                error
            );
        } finally {
            setDeletingFavoriteKey(null);
        }
    };


    // VISIBILITÉ DES AVIS MOVIEFRENZY SUR LE PROFIL
    const handleToggleMovieReviewVisibility = async (review) => {
        const reviewId = review?.id;

        if (!userId || !reviewId) {
            console.error(
                "[MovieFrenzy] Avis ou utilisateur invalide :",
                review
            );
            return;
        }

        const nextVisibleState =
            review.visibleOnProfile === false;

        try {
            setUpdatingMovieReviewId(reviewId);

            const reviewRef = doc(
                db,
                "users",
                userId,
                "movieReviews",
                reviewId
            );

            await updateDoc(reviewRef, {
                visibleOnProfile: nextVisibleState,
                profileVisibilityUpdatedAt: serverTimestamp(),
            });

            setMovieReviews((currentReviews) =>
                currentReviews.map((currentReview) =>
                    currentReview.id === reviewId
                        ? {
                            ...currentReview,
                            visibleOnProfile: nextVisibleState,
                        }
                        : currentReview
                )
            );

            setMovieReviewPages((currentPages) =>
                currentPages.map((page) => ({
                    ...page,

                    reviews: page.reviews.map(
                        (currentReview) =>
                            currentReview.id === reviewId
                                ? {
                                    ...currentReview,
                                    visibleOnProfile:
                                        nextVisibleState,
                                }
                                : currentReview
                    ),
                }))
            );

            setRefreshNeeded(true);
        } catch (error) {
            console.error(
                "[MovieFrenzy] Erreur lors de la modification de la visibilité de l’avis :",
                error
            );
        } finally {
            setUpdatingMovieReviewId(null);
        }
    };


    const handlePreviousMovieReviewsPage = () => {
        if (
            !canGoToPreviousMovieReviewsPage ||
            movieReviewsPageLoading
        ) {
            return;
        }

        const previousPageIndex =
            movieReviewPageIndex - 1;

        const previousPage =
            movieReviewPages[previousPageIndex];

        if (!previousPage) return;

        setMovieReviewPageIndex(previousPageIndex);
        setMovieReviews(previousPage.reviews);
    };


    const handleNextMovieReviewsPage = async () => {
        if (
            !canGoToNextMovieReviewsPage ||
            movieReviewsPageLoading
        ) {
            return;
        }

        const nextPageIndex =
            movieReviewPageIndex + 1;

        const cachedNextPage =
            movieReviewPages[nextPageIndex];

        // Une page déjà consultée est réutilisée
        // sans nouvelle lecture Firestore.
        if (cachedNextPage) {
            setMovieReviewPageIndex(nextPageIndex);
            setMovieReviews(
                cachedNextPage.reviews
            );
            return;
        }

        const currentPage =
            movieReviewPages[movieReviewPageIndex];

        if (!currentPage?.lastDoc) {
            return;
        }

        setMovieReviewsPageLoading(true);

        try {
            const nextPageQuery = query(
                collection(
                    db,
                    "users",
                    userId,
                    "movieReviews"
                ),
                orderBy("updatedAt", "desc"),
                startAfter(currentPage.lastDoc),
                firestoreLimit(movieReviewsPageSize)
            );

            const nextPageSnapshot =
                await getDocs(nextPageQuery);

            const loadedReviews =
                nextPageSnapshot.docs.map(
                    (reviewDoc) => ({
                        id: reviewDoc.id,
                        ...reviewDoc.data(),
                    })
                );

            const lastDoc =
                nextPageSnapshot.docs[
                nextPageSnapshot.docs.length - 1
                ] || null;

            const nextPage = {
                reviews: loadedReviews,
                lastDoc,
            };

            setMovieReviewPages(
                (currentPages) => {
                    const updatedPages = [
                        ...currentPages,
                    ];

                    updatedPages[nextPageIndex] =
                        nextPage;

                    return updatedPages;
                }
            );

            setMovieReviewPageIndex(
                nextPageIndex
            );

            setMovieReviews(loadedReviews);
        } catch (error) {
            console.error(
                "[MovieFrenzy] Erreur lors du chargement de la page suivante :",
                error
            );
        } finally {
            setMovieReviewsPageLoading(false);
        }
    };


    // Au montage du composant
    useEffect(() => {
        const cacheKey = 'countries';
        const cachedCountries = getWithExpiry(cacheKey);
        if (!cachedCountries) {
            const loadedCountries = Country.getAllCountries();
            setWithExpiry(cacheKey, loadedCountries, TTL);
            setAllCountries(loadedCountries);
        } else {
            setAllCountries(cachedCountries);
        }

    }, []);





    console.log("favoritePreviews dans EditProfil.js", favoritePreviews);
    console.log("favoriteMovies dans EditProfil.js", favoriteMovies);

    return (
        <>
            {/* Helmet pour le SEO */}
            <Helmet>
                <title>Éditer votre profil - MovieFrenzy</title>
                <meta name="description" content="Personnalisez votre profil sur MovieFrenzy. Ajoutez votre biographie, vos films favoris, et plus encore pour créer un profil unique !" />
                <meta name="keywords" content="Éditer profil, MovieFrenzy, films favoris, acteurs préférés, biographie" />
                <meta property="og:title" content="Éditez votre profil sur MovieFrenzy" />
                <meta property="og:description" content="Ajoutez votre biographie, sélectionnez vos films favoris, et personnalisez votre profil cinéphile." />
                <meta property="og:image" content={`${process.env.PUBLIC_URL}/images/profil-placeholder.jpg`} />
                <meta property="og:url" content={`https://moviefrenzy.ca/edit-profile/${userId}`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Éditez votre profil - MovieFrenzy" />
                <meta name="twitter:description" content="Personnalisez votre profil cinéphile et partagez vos films préférés avec la communauté MovieFrenzy !" />
            </Helmet>
            <ConfirmFavoriteDialog />
            <Navigation />
            <div className="EditProfil"
                style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL}/images/darkwater.jpg)`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundAttachment: "fixed",
                    backgroundBlendMode: "overlay",
                    backgroundColor: "#200211",
                    opacity: "0.9",
                    overflowX: "hidden",
                    overflowY: "auto",
                    display: "block",
                    zIndex: "10",
                }}
            >
                <div className={styles.container}>
                    <form className="form-group">
                        <h2>{t('editProfile.title')}</h2>
                        <label>{t('editProfile.biography')}</label>
                        <ReactQuill value={biography} onChange={setBiography} style={{ width: '100%' }} />

                        <label>{t('editProfile.quote')}</label>
                        <input type="text" value={quote} onChange={(e) => setQuote(e.target.value)} />

                        <label>{t('editProfile.managePreferences')}</label>
                        <div className="row gestionFavoriteContainer">
                            <h4 className='titreDeSupressionRow'>{t('editProfile.deleteFavoriteMovies')}</h4>
                            <div className="gestionFavorite">
                                {favoritePreviews.map(movie => (
                                    <div
                                        key={movie.id}
                                        className="containerButtonFavorie-1 mf-whimsy-favorite-card"
                                    >

                                        <PreviewMyFavoritesMovies movie={movie} isHoveredId={isHoveredId} />
                                        <span
                                            className="mf-favorite-particle mf-favorite-particle--cyan"
                                            aria-hidden="true"
                                        />

                                        <span
                                            className="mf-favorite-particle mf-favorite-particle--magenta"
                                            aria-hidden="true"
                                        />

                                        <span
                                            className="mf-favorite-particle mf-favorite-particle--pink"
                                            aria-hidden="true"
                                        />
                                        <button
                                            type="button"
                                            onClick={() =>
                                                handleDeleteFavorite("movie", movie.id)
                                            }
                                            className="buttonCloseFavorite0"
                                            disabled={
                                                deletingFavoriteKey === `movie-${movie.id}`
                                            }
                                            onMouseEnter={() => setIsHoveredId(movie.id)}
                                            onMouseLeave={() => setIsHoveredId(null)}
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                fontSize: '1.75rem',
                                                zIndex: 1000,
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faTimesCircle} />
                                        </button>
                                    </div>
                                ))}
                            </div>
                            <h4 className='titreDeSupressionRow'>{t('editProfile.deleteFavoriteActors')}</h4>
                            <div className="gestionFavorite">
                                {favoriteActors.map(actor => (
                                    <div
                                        key={actor.id}
                                        className="containerButtonFavorie-1 mf-whimsy-favorite-card"
                                    >
                                        <MyFavoritesActors actor={actor} isHoveredId={isHoveredId} />
                                        <span
                                            className="mf-favorite-particle mf-favorite-particle--cyan"
                                            aria-hidden="true"
                                        />

                                        <span
                                            className="mf-favorite-particle mf-favorite-particle--magenta"
                                            aria-hidden="true"
                                        />

                                        <span
                                            className="mf-favorite-particle mf-favorite-particle--pink"
                                            aria-hidden="true"
                                        />
                                        <button onClick={() => handleDeleteFavorite('actor', actor.id)} className="buttonCloseFavorite1"
                                            type="button"
                                            disabled={deletingFavoriteKey === `actor-${actor.id}`}
                                            onMouseEnter={() => setIsHoveredId(actor.id)}
                                            onMouseLeave={() => setIsHoveredId(null)}
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                fontSize: '1.75rem',
                                                zIndex: 1000,
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faTimesCircle} />
                                        </button>
                                    </div>
                                ))}
                            </div>
                            <h4 className='titreDeSupressionRow'>{t('editProfile.deleteFavoriteGenres')}</h4>
                            <div className="gestionFavorite_B">
                                {favoriteCategories.map((category) => (
                                    <div
                                        key={category.id}
                                        className="containerButtonFavorie-2 mf-whimsy-favorite-card"
                                    >
                                        <My3FavoriteCategories category={category} />

                                        <span
                                            className="mf-favorite-particle mf-favorite-particle--cyan"
                                            aria-hidden="true"
                                        />

                                        <span
                                            className="mf-favorite-particle mf-favorite-particle--magenta"
                                            aria-hidden="true"
                                        />

                                        <span
                                            className="mf-favorite-particle mf-favorite-particle--pink"
                                            aria-hidden="true"
                                        />

                                        <button
                                            type="button"
                                            onClick={() =>
                                                handleDeleteFavorite("category", category.id)
                                            }
                                            className="buttonCloseFavorite2"
                                            disabled={
                                                deletingFavoriteKey === `category-${category.id}`
                                            }
                                            onMouseEnter={() => setIsHovered(true)}
                                            onMouseLeave={() => setIsHovered(false)}
                                            style={{
                                                background: "none",
                                                border: "none",
                                                fontSize: "1.75rem",
                                                zIndex: 1000,
                                            }}
                                        >
                                            <FontAwesomeIcon
                                                icon={faTimesCircle}
                                                className="FontAwesomeIconClass"
                                            />
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>
                        {/* GESTION DE LA VISIBILITÉ DES AVIS MOVIEFRENZY */}
                        <section className="gestionMovieReviewsSection">
                            <h4 className="titreDeSupressionRow">
                                {t("editProfile.manageMovieReviews")}
                            </h4>

                            {movieReviewsLoading && (
                                <p className="gestionMovieReviewsMessage">
                                    {t("editProfile.movieReviewsLoading")}
                                </p>
                            )}

                            {!movieReviewsLoading &&
                                movieReviewsError && (
                                    <p className="gestionMovieReviewsMessage gestionMovieReviewsMessage--error">
                                        {t(
                                            "editProfile.movieReviewsLoadError"
                                        )}
                                    </p>
                                )}

                            {!movieReviewsLoading &&
                                !movieReviewsError &&
                                movieReviews.length === 0 && (
                                    <p className="gestionMovieReviewsMessage">
                                        {t(
                                            "editProfile.noMovieReviews"
                                        )}
                                    </p>
                                )}

                            {!movieReviewsLoading &&
                                !movieReviewsError &&
                                movieReviews.length > 0 && (
                                    <>
                                        <div className="gestionMovieReviews">
                                            {movieReviews.map((review) => {
                                                const isVisible =
                                                    review.visibleOnProfile !== false;

                                                const posterPath =
                                                    review.moviePosterPath || "";
                                                const posterUrl =
                                                    posterPath.startsWith("http")
                                                        ? posterPath
                                                        : posterPath
                                                            ? `https://image.tmdb.org/t/p/w342${posterPath}`
                                                            : "https://zupimages.net/up/23/13/yd61.jpg";

                                                return (
                                                    <article
                                                        key={review.id}
                                                        className={`editMovieReviewCard ${isVisible
                                                            ? "is-visible"
                                                            : "is-hidden"
                                                            }`}
                                                    >
                                                        <img
                                                            src={posterUrl}
                                                            alt={
                                                                review.movieTitle ||
                                                                t(
                                                                    "movieReviewsCarousel.posterFallbackAlt"
                                                                )
                                                            }
                                                            className="editMovieReviewCard__poster"
                                                        />

                                                        <div className="editMovieReviewCard__content">
                                                            <h5>
                                                                {review.movieTitle ||
                                                                    t(
                                                                        "movieReviewsCarousel.unknownMovie"
                                                                    )}
                                                            </h5>

                                                            <strong>
                                                                {Number(
                                                                    review.rating
                                                                ) || 0}
                                                                /10
                                                            </strong>

                                                            <p>
                                                                {review.reviewExcerpt ||
                                                                    review.reviewText ||
                                                                    ""}
                                                            </p>

                                                            <span className="editMovieReviewCard__status">
                                                                {isVisible
                                                                    ? t(
                                                                        "editProfile.movieReviewVisible"
                                                                    )
                                                                    : t(
                                                                        "editProfile.movieReviewHidden"
                                                                    )}
                                                            </span>

                                                            <button
                                                                type="button"
                                                                className="editMovieReviewCard__toggle"
                                                                disabled={
                                                                    updatingMovieReviewId ===
                                                                    review.id
                                                                }
                                                                onClick={() =>
                                                                    handleToggleMovieReviewVisibility(
                                                                        review
                                                                    )
                                                                }
                                                            >
                                                                {updatingMovieReviewId ===
                                                                    review.id
                                                                    ? t(
                                                                        "editProfile.movieReviewUpdating"
                                                                    )
                                                                    : isVisible
                                                                        ? t(
                                                                            "editProfile.hideMovieReview"
                                                                        )
                                                                        : t(
                                                                            "editProfile.showMovieReview"
                                                                        )}
                                                            </button>
                                                        </div>
                                                    </article>
                                                );
                                            })}
                                        </div>

                                        {movieReviewsTotalPages > 1 && (
                                            <nav
                                                className="gestionMovieReviewsPagination"
                                                aria-label={t(
                                                    "editProfile.movieReviewsPaginationLabel"
                                                )}
                                            >
                                                <button
                                                    type="button"
                                                    className="gestionMovieReviewsPagination__button"
                                                    onClick={
                                                        handlePreviousMovieReviewsPage
                                                    }
                                                    disabled={
                                                        !canGoToPreviousMovieReviewsPage ||
                                                        movieReviewsPageLoading
                                                    }
                                                >
                                                    ‹{" "}
                                                    {t(
                                                        "editProfile.movieReviewsPreviousPage"
                                                    )}
                                                </button>

                                                <span className="gestionMovieReviewsPagination__status">
                                                    {t("editProfile.movieReviewsPageStatus")
                                                        .replace(
                                                            "{{current}}",
                                                            String(movieReviewPageIndex + 1)
                                                        )
                                                        .replace(
                                                            "{{total}}",
                                                            String(movieReviewsTotalPages)
                                                        )}
                                                </span>
                                                <button
                                                    type="button"
                                                    className="gestionMovieReviewsPagination__button"
                                                    onClick={
                                                        handleNextMovieReviewsPage
                                                    }
                                                    disabled={
                                                        !canGoToNextMovieReviewsPage ||
                                                        movieReviewsPageLoading
                                                    }
                                                >
                                                    {t(
                                                        "editProfile.movieReviewsNextPage"
                                                    )}{" "}
                                                    ›
                                                </button>
                                            </nav>
                                        )}
                                    </>
                                )}
                        </section>

                        <label style={{ marginTop: '0.75rem' }}>
                            {t('editProfile.sexGenre')}
                        </label>
                        <select value={gender} onChange={(e) => setGender(e.target.value)}>
                            <option value="other">{t('gender.other')}</option>
                            <option value="male">{t('gender.male')}</option>
                            <option value="female">{t('gender.female')}</option>
                            <option value="nonbinary">{t('gender.nonbinary')}</option>
                            <option value="preferNotToSay">{t('gender.preferNotToSay')}</option>
                        </select>

                        <label>{t('editProfile.age')}</label>
                        <input type="number" value={age} onChange={(e) => setAge(e.target.value)} />
                        <label>{t('editProfile.zodiacSign')}</label>
                        <select value={zodiacSign} onChange={(e) => setZodiacSign(e.target.value)}>
                            <option value="aquarius" style={{ backgroundImage: `url(https://zupimages.net/up/23/41/xucf.png)`, backgroundSize: '32px 32px' }}>{t('zodiac.aquarius')}</option>
                            <option value="aries" style={{ backgroundImage: `url(https://zupimages.net/up/23/41/t314.png)`, backgroundSize: '32px 32px' }}>{t('zodiac.aries')}</option>
                            <option value="capricorn" style={{ backgroundImage: `url(https://zupimages.net/up/23/41/j92j.png)`, backgroundSize: '32px 32px' }}>{t('zodiac.capricorn')}</option>
                            <option value="cancer" style={{ backgroundImage: `url(https://zupimages.net/up/23/41/2xbb.png)`, backgroundSize: '32px 32px' }}>{t('zodiac.cancer')}</option>
                            <option value="gemini" style={{ backgroundImage: `url(https://zupimages.net/up/23/41/6xwq.png)`, backgroundSize: '32px 32px' }}>{t('zodiac.gemini')}</option>
                            <option value="leo" style={{ backgroundImage: `url(https://zupimages.net/up/23/41/0ilk.png)`, backgroundSize: '32px 32px' }}>{t('zodiac.leo')}</option>
                            <option value="libra" style={{ backgroundImage: `url(https://zupimages.net/up/23/41/yeo8.png)`, backgroundSize: '32px 32px' }}>{t('zodiac.libra')}</option>
                            <option value="pisces" style={{ backgroundImage: `url(https://zupimages.net/up/23/41/jlxa.png)`, backgroundSize: '32px 32px' }}>{t('zodiac.pisces')}</option>
                            <option value="sagittarius" style={{ backgroundImage: `url(https://zupimages.net/up/23/41/g5m1.png)`, backgroundSize: '32px 32px' }}>{t('zodiac.sagittarius')}</option>
                            <option value="scorpio" style={{ backgroundImage: `url(https://zupimages.net/up/23/41/wiyy.png)`, backgroundSize: '32px 32px' }}>{t('zodiac.scorpio')}</option>
                            <option value="taurus" style={{ backgroundImage: `url(https://zupimages.net/up/23/41/50i8.png)`, backgroundSize: '32px 32px' }}>{t('zodiac.taurus')}</option>
                            <option value="virgo" style={{ backgroundImage: `url(https://zupimages.net/up/23/41/zmar.png)`, backgroundSize: '32px 32px' }}>{t('zodiac.virgo')}</option>
                        </select>
                        <label>{t('editProfile.occupation')}</label>
                        <select value={occupation} onChange={(e) => setOccupation(e.target.value)}>
                            <option value="student">{t('occupation.student')}</option>
                            <option value="employee">{t('occupation.employee')}</option>
                            <option value="entrepreneur">{t('occupation.entrepreneur')}</option>
                            <option value="liberal_profession">{t('occupation.liberal_profession')}</option>
                            <option value="teacher">{t('occupation.teacher')}</option>
                            <option value="researcher_scientist">{t('occupation.researcher_scientist')}</option>
                            <option value="engineer">{t('occupation.engineer')}</option>
                            <option value="technician">{t('occupation.technician')}</option>
                            <option value="doctor">{t('occupation.doctor')}</option>
                            <option value="nurse">{t('occupation.nurse')}</option>
                            <option value="lawyer">{t('occupation.lawyer')}</option>
                            <option value="accountant">{t('occupation.accountant')}</option>
                            <option value="salesperson">{t('occupation.salesperson')}</option>
                            <option value="artist">{t('occupation.artist')}</option>
                            <option value="artisan">{t('occupation.artisan')}</option>
                            <option value="manager">{t('occupation.manager')}</option>
                            <option value="civil_servant">{t('occupation.civil_servant')}</option>
                            <option value="military">{t('occupation.military')}</option>
                            <option value="farmer">{t('occupation.farmer')}</option>
                            <option value="retired">{t('occupation.retired')}</option>
                            <option value="unemployed">{t('occupation.unemployed')}</option>
                            <option value="other">{t('occupation.other')}</option>
                            <option value="preferNotToSay">{t('occupation.preferNotToSay')}</option>
                        </select>

                        <label>{t('editProfile.country')}</label>
                        <select value={country} onChange={(e) => handleCountryChange(e.target.value)}>
                            {allCountries.map(c => {
                                // console.log("Option de pays :", c.isoCode);  // Ajout du console.log
                                return <option key={c.isoCode} value={c.isoCode}>{c.name}</option>;
                            })}
                        </select>
                        <label>{t('editProfile.stateProvince')}</label>
                        {states.length > 0 && (
                            <select value={state} onChange={(e) => setState(e.target.value)}>
                                {states.map(s => {
                                    // console.log("Option d'état :", s.isoCode);  // Ajout du console.log
                                    return <option key={s.isoCode} value={s.isoCode}>{s.name}</option>;
                                })}
                            </select>
                        )}
                        <label>{t('editProfile.city')}</label>
                        {cities.length > 0 && (
                            <select value={city} onChange={(e) => setCity(e.target.value)}>
                                {cities.map(c => {
                                    // console.log("Option de ville :", c.name);  // Ajout du console.log
                                    return <option key={c.name} value={c.name}>{c.name}</option>;
                                })}
                            </select>
                        )}
                        <label>{t('editProfile.favoritePreview')}</label>
                        <div className="searchMovieContainer">
                            <SearchMovieForEdit onMovieSelected={handleMovieSelected} />
                        </div>
                        <button type="button" onClick={handleSave} className='btnEditProfil'>{t('editProfile.save')}</button>
                    </form>
                </div>
            </div>
            <div className="actor-details-footer"
                style={{ maxWidth: '100%', maxHeight: '100%', zIndex: 15, position: 'relative' }}
            >
                <Footer />
            </div>
        </>

    );

};
export default EditProfil;







